import { Adress } from "./jmApiResponses";
export type ImportError = {
  originAdress: Adress;
  message: string;
};
export enum ImportAnalysisType {
  JobMOBILEETY = "JobMOBILEETY",
  BizMOBILEETY = "BizMOBILEETY",
}
/**
 * If you want to use ImportSettings for posting an
 * import, you will have to have defined officeId!
 */
export type ImportSettings = {
  officeName: string;
  transports: Transport[];
  // geocoding: boolean;
  // typeOfAnalysis: ImportAnalysisType;
  officeId?: number;
  importSessionId?: string;
};
export enum ImportStatus {
  Pending = "wartet...",
  Stopped = "gestoppt..",
  Finished = "fertig!",
}
export enum Transport {
  car = "Auto",
  car_electric = "E-Auto",
  train = "ÖV",
  bike = "Fahrrad",
  eBike = "Pedelec",
  bike_and_ride = "Bike & Ride",
  park_and_ride = "Park & Ride",
  walk = "Fußweg",
  taxi = "Taxi",
  ride_and_taxi = "Taxi & Ride",
  park_ride_and_taxi = "Park & Ride & Taxi",
}
export type CleverRouteImport = {
  errors: ImportError[];
  settings: ImportSettings;
  status: ImportStatus | number;
  id?: number;
};
export type ImportSettingsInput = {
  projectId: number | undefined | null;
  companyId: number | undefined | null;
  officeId: number | undefined | null;
  geocoding: boolean;
  transports: Transport[];
  typeOfAnalysis: ImportAnalysisType;
};
export enum StoppingStatus {
  Pending,
  Confirmed,
  None,
}
